// extracted by mini-css-extract-plugin
export default {"mainContainer":"CustomDetails_mainContainer__QDfHD","headerContainer":"CustomDetails_headerContainer__8zfoe","dataContainer":"CustomDetails_dataContainer__nxo3N"};